export const header = () => {
	const container = document.querySelector('.js-header');
	if (!container) return;

	const mainHeader = container.querySelector('.header-main');
	let mainHeaderHeight = mainHeader.offsetHeight;

	const tabletMQ = window.matchMedia(`(min-width: ${vars.breakpoint.tablet}px)`);
	const laptopMQ = window.matchMedia(`(min-width: ${vars.breakpoint.laptop}px)`);

	let lastScrollY = 0;
	let scrollDirection = 'down';
	let dynamicThreshold = laptopMQ.matches ? 48 : mainHeaderHeight;

	const handleWindowScroll = () => {
		const offsetY = window.scrollY;
		const isLaptop = laptopMQ.matches;
		const baseThreshold = isLaptop ? 48 : 94;

		const isScrollingDown = offsetY > lastScrollY;
		const isScrollingUp = offsetY < lastScrollY;

		if (isScrollingDown && scrollDirection !== 'down') {
			dynamicThreshold = offsetY;
			scrollDirection = 'down';
		} else if (isScrollingUp) {
			scrollDirection = 'up';
		}

		lastScrollY = offsetY;

		if (isLaptop) {
			const shouldBeSticky = offsetY > baseThreshold;
			container.classList.toggle('sticky', shouldBeSticky);
			return;
		}

		const shouldShowStickyOnMobile = scrollDirection === 'up' && offsetY > baseThreshold;
		const shouldHideStickyOnMobile = scrollDirection === 'down' && offsetY > dynamicThreshold;

		if (shouldShowStickyOnMobile) {
			container.classList.add('sticky');
			dynamicThreshold = 0;
		} else if (shouldHideStickyOnMobile) {
			container.classList.remove('sticky');
		}
	};

	const handleTabletMQChange = () => {
		mainHeaderHeight = mainHeader.offsetHeight;
	};

	window.addEventListener('scroll', handleWindowScroll, { passive: true });
	tabletMQ.addEventListener('change', handleTabletMQChange);

	handleWindowScroll();
};
